import { createFileRoute, redirect } from '@tanstack/react-router'
import { DepartmentList } from '@/features/departments/department-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the departments screen (FR-CMP-003).
 *
 * The grant gate is presentation only — the API enforces `company.view` on
 * the department endpoints; this only keeps a user without the grant out of
 * a screen they cannot use.
 */
export const Route = createFileRoute('/_authenticated/departments')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'company.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: DepartmentList,
})
